// Chaves de público do envio único. O backend exige exatamente uma delas (xor).
export const UNIFIED_SEND_AUDIENCE_KEYS = [
  'clientCategoryId',
  'customerGroupId',
  'stationGroupId',
  'customerTagId',
  'stationTagId',
  'customerIds',
] as const

const hasValue = (value: unknown) =>
  Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== ''

// Validate do form inteiro: os 5 selects de público não têm validate próprio, então o
// form enviava sem público nenhum e o backend respondia 400 (xor). A tela do cliente
// preenche `customerIds` por defaultValues e passa.
export const validateUnifiedSendAudience = (values: Record<string, any>) =>
  UNIFIED_SEND_AUDIENCE_KEYS.some((key) => hasValue(values?.[key]))
    ? {}
    : { clientCategoryId: 'Escolha pelo menos um público' }
